import { combineReducers } from 'redux';
import raffleTicketReducer from './raffleTicketReducer';
import raffleResultReducer from './raffleResultReducer';

export default combineReducers({
  raffleTickets: raffleTicketReducer,
  raffleResults: raffleResultReducer
});
